import { FollowUpsBucketPage } from '../../components/common/LeadFollowUpViews';

export default function AgentFollowUps() {
  return <FollowUpsBucketPage roleBasePath="/agent" />;
}
